import {
  type BillingProfileDomainSelectModel,
  BillingProfileId,
  BillingServiceId,
  OrganizationId,
} from '@mntn-dev/domain-types'
import { MockModel } from './mock-model.ts'

export const MockBillingProfile = MockModel<BillingProfileDomainSelectModel>(
  ({
    billingProfileId = BillingProfileId(),
    organizationId = OrganizationId(),
    billingServiceId = BillingServiceId(),
    billingSchedule = '100_up_front',
    currency = 'USD',
    invoiceTerms = 'none',
    defaultProfile = false,
  }) =>
    ({
      billingProfileId,
      organizationId,
      billingServiceId,
      billingSchedule,
      currency,
      invoiceTerms,
      defaultProfile,
    }) satisfies BillingProfileDomainSelectModel
)
